export interface ObjectDifferences<T = unknown> {
  hasChanges: boolean;
  added: Record<string, T>;
  removed: Record<string, T>;
  changed: Record<string, { before: T; after: T }>;
}
